export default __webpack_public_path__ + "static/media/contratar_03.3770510a.jpg";